/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Descriptionlabel1Inputs */

const zh_course_descriptionlabel1 = /** @type {(inputs: Course_Descriptionlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程描述`)
};

const en_course_descriptionlabel1 = /** @type {(inputs: Course_Descriptionlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const es_course_descriptionlabel1 = /** @type {(inputs: Course_Descriptionlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Course_Descriptionlabel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_descriptionlabel1 = /** @type {((inputs?: Course_Descriptionlabel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Descriptionlabel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_descriptionlabel1(inputs)
	if (locale === "en") return en_course_descriptionlabel1(inputs)
	return es_course_descriptionlabel1(inputs)
});
export { course_descriptionlabel1 as "course_descriptionLabel" }